import { useRootStore } from '@/contexts';
import jsCookie from 'js-cookie';
import { TOKEN_KEY } from '@/constants';
import { useEffect } from 'react';
import { openAuthModal } from '@/components/AuthModal/authModalController';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * 路由守卫组件，用于保护需要登录才能访问的路由
 * 如果用户未登录，将重定向到登录页
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { userStore } = useRootStore();
  
  // 检查用户是否已登录：以 token 作为访问受保护页面的准入条件。
  const token = jsCookie.get(TOKEN_KEY);
  const isAuthenticated = !!token;

  useEffect(() => {
    if (!isAuthenticated) {
      userStore.clearUser();
      openAuthModal({ reason: 'protected-route' });
    }
  }, [isAuthenticated, userStore]);

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
